const API_BASE_URL = 'http://localhost:3001/api';

class DemographicsModel {
  static async getDemographics() {
    const response = await fetch(`${API_BASE_URL}/demographics`);
    if (!response.ok) throw new Error('Failed to fetch demographics data');
    return response.json();
  }

  static async getAgeDistribution() {
    const response = await fetch(`${API_BASE_URL}/age-distribution`);
    if (!response.ok) throw new Error('Failed to fetch age distribution data');
    return response.json();
  }

  static async getCountries() {
    const response = await fetch(`${API_BASE_URL}/countries`);
    if (!response.ok) throw new Error('Failed to fetch countries data');
    return response.json();
  }

  static async getGenderDistribution() {
    const response = await fetch(`${API_BASE_URL}/gender-distribution`);
    if (!response.ok) throw new Error('Failed to fetch gender distribution data');
    return response.json();
  }
}

export default DemographicsModel; 